
import s0 from '~/.nuxt/gb-cms/sections/AboutUs'
import s1 from '~/.nuxt/gb-cms/sections/AboutUsTwoImages'
import s2 from '~/.nuxt/gb-cms/sections/BackgroundBox'
import s3 from '~/.nuxt/gb-cms/sections/BestSellingProductsSection'
import s4 from '~/.nuxt/gb-cms/sections/Catalogs'
import s5 from '~/.nuxt/gb-cms/sections/Inspiration'
import s6 from '~/.nuxt/gb-cms/sections/LastViewed'
import s7 from '~/.nuxt/gb-cms/sections/NewOffer'
import s8 from '~/.nuxt/gb-cms/sections/News'
import s9 from '~/.nuxt/gb-cms/sections/NewsLetter'
import s10 from '~/.nuxt/gb-cms/sections/Policy'
import s11 from '~/.nuxt/gb-cms/sections/ProductSection'
import s12 from '~/.nuxt/gb-cms/sections/SponsorSlider'
import s13 from '~/.nuxt/gb-cms/sections/WeSingleOut'
import s14 from '~/.nuxt/gb-cms/sections/AdditionalEquipTub'
import s15 from '~/.nuxt/gb-cms/sections/BuyFromCollection'
import s16 from '~/.nuxt/gb-cms/sections/ChildrenRoom'
import s17 from '~/.nuxt/gb-cms/sections/ContactUs'
import s18 from '~/.nuxt/gb-cms/sections/FindBoxFilters'
import s19 from '~/.nuxt/gb-cms/sections/InsatgramSection'
import s20 from '~/.nuxt/gb-cms/sections/OurBranches'
import s21 from '~/.nuxt/gb-cms/sections/WePresent'
import s22 from '~/.nuxt/gb-cms/sections/YouMightBeInterested'

const sectionMapper = {
	'about-us': s0,
	'about-us-two-images': s1,
	'background-box': s2,
	'best-selling-products-section': s3,
	'catalogs': s4,
	'inspiration': s5,
	'last-viewed': s6,
	'new-offer': s7,
	'news': s8,
	'news-letter': s9,
	'policy': s10,
	'product-section': s11,
	'sponsor-slider': s12,
	'we-single-out': s13,
	'additional-equip-tub': s14,
	'buy-from-collection': s15,
	'children-room': s16,
	'contact-us': s17,
	'find-box-filters': s18,
	'insatgram-section': s19,
	'our-branches': s20,
	'we-present': s21,
	'you-might-be-interested': s22
}

export default sectionMapper
